import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-card" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "properties-title" }
const _hoisted_4 = { class: "tab-text" }
const _hoisted_5 = { class: "tab-text" }
const _hoisted_6 = {
  key: 0,
  class: "loading"
}
const _hoisted_7 = {
  key: 1,
  class: "loading-error"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "properties-container"
}
const _hoisted_10 = { class: "metadata-row" }
const _hoisted_11 = { class: "metadata-label" }
const _hoisted_12 = { class: "metadata-value" }
const _hoisted_13 = { class: "metadata-row" }
const _hoisted_14 = { class: "metadata-label" }
const _hoisted_15 = { class: "metadata-value" }
const _hoisted_16 = { class: "metadata-row" }
const _hoisted_17 = { class: "metadata-label" }
const _hoisted_18 = { class: "metadata-value" }
const _hoisted_19 = { class: "metadata-row" }
const _hoisted_20 = { class: "metadata-label" }
const _hoisted_21 = { class: "metadata-value" }
const _hoisted_22 = { class: "metadata-row" }
const _hoisted_23 = { class: "metadata-label" }
const _hoisted_24 = { class: "metadata-value" }
const _hoisted_25 = { class: "metadata-row" }
const _hoisted_26 = { class: "metadata-label" }
const _hoisted_27 = { class: "metadata-value" }
const _hoisted_28 = {
  key: 0,
  class: "metadata-row"
}
const _hoisted_29 = { class: "metadata-label" }
const _hoisted_30 = { class: "metadata-value" }
const _hoisted_31 = {
  key: 1,
  class: "metadata-row"
}
const _hoisted_32 = { class: "metadata-label" }
const _hoisted_33 = { class: "metadata-value" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "properties-status-seperator" }, null, -1)
const _hoisted_35 = { class: "metadata-row" }
const _hoisted_36 = { class: "metadata-label" }
const _hoisted_37 = { class: "metadata-value" }
const _hoisted_38 = { class: "logs-table-container" }
const _hoisted_39 = {
  key: 0,
  class: "loading"
}
const _hoisted_40 = {
  key: 1,
  class: "loading-error"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_42 = {
  class: "dialog-actions",
  style: {"margin-right":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_tab = _resolveComponent("imdex-tab")!
  const _component_imdex_tabs = _resolveComponent("imdex-tabs")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_tab_item = _resolveComponent("imdex-tab-item")!
  const _component_imdex_table = _resolveComponent("imdex-table")!
  const _component_imdex_tab_items = _resolveComponent("imdex-tab-items")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name) + " " + _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.title")), 1),
      _createVNode(_component_imdex_tabs, {
        class: "tabs",
        value: _ctx.tab,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx((slot) => [
          (_openBlock(), _createBlock(_component_imdex_tab, {
            onClick: ($event: any) => (slot.scope(0)),
            key: 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.detailsTab")), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])),
          (_openBlock(), _createBlock(_component_imdex_tab, {
            onClick: ($event: any) => (slot.scope(1)),
            key: 1
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.logsTab")), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_imdex_tab_items, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_imdex_tab_item, {
            hidden: _ctx.tab != 0,
            key: 0
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_imdex_spinner, {
                      width: "70",
                      size: "4",
                      indeterminite: "",
                      color: "#808080"
                    })
                  ]))
                : (_ctx.errorFetchingLogs)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.errorFetch")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelName")), 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelType")), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.datasetType), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelGroup")), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.group), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelSize")), 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatBytes(_ctx.properties.datasetSize)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelCreated")), 1),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatDateTime(new Date(_ctx.properties.createdAt))), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelCreatedBy")), 1),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.properties.createdBy), 1)
                      ]),
                      (_ctx.properties.updatedAt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelLastUpdated")), 1),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formatDateTime(new Date(_ctx.properties.updatedAt))), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.properties.updatedBy)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelUpdatedBy")), 1),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.properties.updatedBy), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.labelImportStatus")), 1),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.status), 1)
                      ])
                    ]))
            ]),
            _: 1
          }, 8, ["hidden"])),
          (_openBlock(), _createBlock(_component_imdex_tab_item, {
            hidden: _ctx.tab != 1,
            key: 1
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_38, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createVNode(_component_imdex_spinner, {
                        width: "70",
                        size: "4",
                        indeterminite: "",
                        color: "#808080"
                      })
                    ]))
                  : (_ctx.errorFetchingLogs)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.errorFetch")), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_imdex_table, {
                        key: 2,
                        tableData: _ctx.logsTableData
                      }, {
                        "h-date_&_time": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.tableHeadDate&Time")), 1)
                        ]),
                        "h-type": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.tableHeadType")), 1)
                        ]),
                        "h-file_path": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.tableHeadFilePath")), 1)
                        ]),
                        "h-message": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.tableHeadMsg")), 1)
                        ]),
                        _: 1
                      }, 8, ["tableData"]))
              ])
            ]),
            _: 1
          }, 8, ["hidden"]))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createVNode(_component_imdex_btn, {
        text: "",
        onClick: _ctx.handleCloseCallback
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ssa.hierarchy.datasetPropertiesAndLogs.close")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}